import { render, staticRenderFns } from "./Taskdefinition.vue?vue&type=template&id=43af49b2&scoped=true"
import script from "./Taskdefinition.vue?vue&type=script&lang=js"
export * from "./Taskdefinition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43af49b2",
  null
  
)

export default component.exports